import React from 'react';
import {
  Alert,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import styled from 'styled-components';

import logo from './images/RedRiverGlazing_Logo.png';
const NavDiv = styled.div`
  background-image: linear-gradient(135deg, #abdcff 0%, #0396ff 100%);
  color: #393f4d;
  font-family: 'Helvetica', sans-serif;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
`;

const PhoneDiv = styled.div`
  margin: 'auto';

  @media (max-width: 576px) {
    height: 30px;
    margin: 10px 0;
    width: 100%;
  }
`;
export default class Navigation extends React.Component {
  state = {};

  toggle = () => {
    this.setState({ navbarTogglerOpen: !this.state.navbarTogglerOpen });
  };
  render() {
    return (
      <NavDiv>
        <Navbar style={{ padding: '0rem 1rem' }} light expand="lg">
          <NavbarBrand href="/">
            <img
              src={logo}
              alt={'Red River Glazing'}
              style={{ width: '280px' }}
            />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.navbarTogglerOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem style={{ margin: 'auto' }}>
                <NavLink href="/commercialproducts/">
                  Commercial Products
                </NavLink>
              </NavItem>
              <NavItem style={{ margin: 'auto' }}>
                <NavLink href="/showers/">Showers</NavLink>
              </NavItem>
              <NavItem style={{ margin: 'auto' }}>
                <NavLink href="/mirrors/">Mirrors</NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink href="/team/">Team</NavLink>
              </NavItem> */}
              <NavItem>
                <Alert
                  className="border-right-0 border-left-0 border-bottom-0 border-top-0"
                  style={{
                    background: 'rgba(255,255,255,.2)',
                    borderRadius: '0',
                    color: '#393f4d',
                    lineHeight: '.25',
                    margin: 'auto'
                  }}
                >
                  <PhoneDiv>
                    <p
                      style={{
                        whiteSpace: 'nowrap',
                        fontSoze: '15px',
                        textDecoration: 'underline'
                      }}
                    >
                      Contact Us
                    </p>
                    <p style={{ whiteSpace: 'nowrap', fontSize: '15px' }}>
                      (701) 232-4717
                    </p>
                    <p style={{ whiteSpace: 'nowrap' }}>
                      <a
                        style={{ color: 'inherit' }}
                        href="mailto:contact@redriverglazing.com"
                      >
                        contact@redriverglazing.com
                      </a>
                    </p>
                  </PhoneDiv>
                </Alert>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </NavDiv>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Nav.js